// @flow
import React, { Suspense, lazy, useMemo } from 'react'
import cx from 'classnames'

import './style.sass'

const Analytics = lazy(() => import('../../icons/Analytics'))
const AddContact = lazy(() => import('../../icons/AddUserPlus'))
const Hamburger = lazy(() => import('../../icons/Hamburger'))
const ArrowRight = lazy(() => import('../../icons/ArrowRight'))
const ArrowLeft = lazy(() => import('../../icons/ArrowLeft'))
const ChevronDown = lazy(() => import('../../icons/ChevronDown'))
const ChevronLeft = lazy(() => import('../../icons/ChevronLeft'))
const ChevronRight = lazy(() => import('../../icons/ChevronRight'))
const Clock = lazy(() => import('../../icons/Clock'))
const Eye = lazy(() => import('../../icons/Eye'))
const EyeOff = lazy(() => import('../../icons/EyeOff'))
const QuestionMark = lazy(() => import('../../icons/QuestionMark'))
const Close = lazy(() => import('../../icons/Close'))
const Edit = lazy(() => import('../../icons/Edit'))
const Comment = lazy(() => import('../../icons/Comment'))
const Trash = lazy(() => import('../../icons/Trash'))
const User = lazy(() => import('../../icons/User'))
const UserChecked = lazy(() => import('../../icons/UserCheck'))
const UserX = lazy(() => import('../../icons/UserX'))
const UserMinus = lazy(() => import('../../icons/UserMinus'))
const Refresh = lazy(() => import('../../icons/Refresh'))
const Download = lazy(() => import('../../icons/Download'))
const MoreHorizontal = lazy(() => import('../../icons/MoreHorizontal'))
const UploadCloud = lazy(() => import('../../icons/UploadCloud'))
const Plus = lazy(() => import('../../icons/Plus'))
const FolderPlus = lazy(() => import('../../icons/FolderPlus'))
const PlusSquare = lazy(() => import('../../icons/PlusSquare'))
const NewTab = lazy(() => import('../../icons/NewTab'))
const ToggleRight = lazy(() => import('../../icons/ToggleRight'))
const ToggleLeft = lazy(() => import('../../icons/ToggleLeft'))
const SecurityIcon = lazy(() => import('../../icons/Security'))
const CheckedSquare = lazy(() => import('../../icons/CheckedSquare'))

const icons = {
	analytics: (props: Object): React$Element<React$AbstractComponent<any, any>> => <Analytics stroke='#3B57F7' {...props} />,
	'add-contact': (props: Object): React$Element<React$AbstractComponent<any, any>> => (
		<AddContact stroke='#3B57F7' {...props} />
	),
	hamburger: (props: Object): React$Element<React$AbstractComponent<any, any>> => <Hamburger stroke='#3B57F7' {...props} />,
	'arrow-right': (props: Object): React$Element<React$AbstractComponent<any, any>> => (
		<ArrowRight stroke='#3B57F7' {...props} />
	),
	'arrow-left': (props: Object): React$Element<React$AbstractComponent<any, any>> => <ArrowLeft stroke='#3B57F7' {...props} />,
	'chevron-down': (props: Object): React$Element<React$AbstractComponent<any, any>> => (
		<ChevronDown stroke='#3B57F7' {...props} />
	),
	'chevron-left': (props: Object): React$Element<React$AbstractComponent<any, any>> => (
		<ChevronLeft stroke='#3B57F7' {...props} />
	),
	'chevron-right': (props: Object): React$Element<React$AbstractComponent<any, any>> => (
		<ChevronRight stroke='#3B57F7' {...props} />
	),
	eye: (props: Object): React$Element<React$AbstractComponent<any, any>> => <Eye stroke='#3B57F7' {...props} />,
	eyeOff: (props: Object): React$Element<React$AbstractComponent<any, any>> => <EyeOff stroke='#3B57F7' {...props} />,
	questionmark: (props: Object): React$Element<React$AbstractComponent<any, any>> => (
		<QuestionMark stroke='#3B57F7' {...props} />
	),
	close: (props: Object): React$Element<React$AbstractComponent<any, any>> => <Close stroke='#3B57F7' {...props} />,
	clock: (props: Object): React$Element<React$AbstractComponent<any, any>> => <Clock stroke='#3B57F7' {...props} />,
	edit: (props: Object): React$Element<React$AbstractComponent<any, any>> => <Edit stroke='#3B57F7' {...props} />,
	comment: (props: Object): React$Element<React$AbstractComponent<any, any>> => <Comment stroke='#3B57F7' {...props} />,
	trash: (props: Object): React$Element<React$AbstractComponent<any, any>> => <Trash stroke='#3B57F7' {...props} />,
	user: (props: Object): React$Element<React$AbstractComponent<any, any>> => <User stroke='#3B57F7' {...props} />,
	checked_square: (props: Object): React$Element<React$AbstractComponent<any, any>> => (
		<CheckedSquare stroke='#3B57F7' {...props} />
	),
	user_checked: (props: Object): React$Element<React$AbstractComponent<any, any>> => (
		<UserChecked stroke='#3B57F7' {...props} />
	),
	'user-x': (props: Object): React$Element<React$AbstractComponent<any, any>> => <UserX stroke='#3B57F7' {...props} />,
	'user-minus': (props: Object): React$Element<React$AbstractComponent<any, any>> => <UserMinus stroke='#3B57F7' {...props} />,
	refresh: (props: Object): React$Element<React$AbstractComponent<any, any>> => <Refresh stroke='#3B57F7' {...props} />,
	download: (props: Object): React$Element<React$AbstractComponent<any, any>> => <Download stroke='#3B57F7' {...props} />,
	'more-horizontal': (props: Object): React$Element<React$AbstractComponent<any, any>> => (
		<MoreHorizontal stroke='#3B57F7' {...props} />
	),
	'upload-cloud': (props: Object): React$Element<React$AbstractComponent<any, any>> => (
		<UploadCloud stroke='#3B57F7' {...props} />
	),
	plus: (props: Object): React$Element<React$AbstractComponent<any, any>> => <Plus stroke='#3B57F7' {...props} />,
	'folder-open': (props: Object): React$Element<React$AbstractComponent<any, any>> => (
		<FolderPlus stroke='#3B57F7' {...props} />
	),
	'plus-square': (props: Object): React$Element<React$AbstractComponent<any, any>> => (
		<PlusSquare stroke='#3B57F7' {...props} />
	),
	'new-tab': (props: Object): React$Element<React$AbstractComponent<any, any>> => <NewTab stroke='#3B57F7' {...props} />,
	'toggle-right': (props: Object): React$Element<React$AbstractComponent<any, any>> => (
		<ToggleRight stroke='#3B57F7' {...props} />
	),
	'toggle-left': (props: Object): React$Element<React$AbstractComponent<any, any>> => (
		<ToggleLeft stroke='#3B57F7' {...props} />
	),
	security: (props: Object): React$Element<React$AbstractComponent<any, any>> => <SecurityIcon stroke='#3B57F7' {...props} />,
	chat: ({ width = 20, height = 20, stroke = '#000000', ...props }: Object): React$Element<'svg'> => (
		<svg {...props} width={width} height={height} viewBox='0 0 20 20' fill='none' xmlns='http://www.w3.org/2000/svg'>
			<path
				d='M19 13C19 13.5304 18.7893 14.0391 18.4142 14.4142C18.0391 14.7893 17.5304 15 17 15H5L1 19V3C1 2.46957 1.21071 1.96086 1.58579 1.58579C1.96086 1.21071 2.46957 1 3 1H17C17.5304 1 18.0391 1.21071 18.4142 1.58579C18.7893 1.96086 19 2.46957 19 3V13Z'
				stroke={stroke}
				strokeWidth='2'
				strokeLinecap='round'
				strokeLinejoin='round'
			/>
		</svg>
	),

	inbox: ({ width = 24, height = 24, ...props }: Object): React$Element<'svg'> => (
		<svg {...props} width={width} height={height} viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'>
			<path
				d='M4 4H20C21.1 4 22 4.9 22 6V18C22 19.1 21.1 20 20 20H4C2.9 20 2 19.1 2 18V6C2 4.9 2.9 4 4 4Z'
				stroke='#ffffff'
				strokeWidth='2'
				strokeLinecap='round'
				strokeLinejoin='round'
			/>
			<path d='M22 6L12 13L2 6' stroke='#ffffff' strokeWidth='2' strokeLinecap='round' strokeLinejoin='round' />
		</svg>
	),
	send: ({ width = 24, height = 24, ...props }: Object): React$Element<'svg'> => (
		<svg {...props} width={width} height={height} viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'>
			<path d='M22 2L11 13' stroke='#ffffff' strokeWidth='2' strokeLinecap='round' strokeLinejoin='round' />
			<path d='M22 2L15 22L11 13L2 9L22 2Z' stroke='ffffff' strokeWidth='2' strokeLinecap='round' strokeLinejoin='round' />
		</svg>
	),
	group: ({ width = 24, height = 24, stroke = '', ...props }: Object): React$Element<'svg'> => (
		<svg {...props} width={width} height={height} viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'>
			<path
				d='M17 21V19C17 17.9391 16.5786 16.9217 15.8284 16.1716C15.0783 15.4214 14.0609 15 13 15H5C3.93913 15 2.92172 15.4214 2.17157 16.1716C1.42143 16.9217 1 17.9391 1 19V21'
				stroke={stroke}
				strokeWidth='2'
				strokeLinecap='round'
				strokeLinejoin='round'
			/>
			<path
				d='M9 11C11.2091 11 13 9.20914 13 7C13 4.79086 11.2091 3 9 3C6.79086 3 5 4.79086 5 7C5 9.20914 6.79086 11 9 11Z'
				stroke={stroke}
				strokeWidth='2'
				strokeLinecap='round'
				strokeLinejoin='round'
			/>
			<path
				d='M23 21V19C22.9993 18.1137 22.7044 17.2528 22.1614 16.5523C21.6184 15.8519 20.8581 15.3516 20 15.13'
				stroke={stroke}
				strokeWidth='2'
				strokeLinecap='round'
				strokeLinejoin='round'
			/>
			<path
				d='M16 3.13C16.8604 3.35031 17.623 3.85071 18.1676 4.55232C18.7122 5.25392 19.0078 6.11683 19.0078 7.005C19.0078 7.89318 18.7122 8.75608 18.1676 9.45769C17.623 10.1593 16.8604 10.6597 16 10.88'
				stroke={stroke}
				strokeWidth='2'
				strokeLinecap='round'
				strokeLinejoin='round'
			/>
		</svg>
	),
	'credit-card': ({ height = 24, width = 24, ...props }: Object): React$Element<'svg'> => (
		<svg {...props} width={width} height={height} viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'>
			<path
				d='M21 4H3C1.89543 4 1 4.89543 1 6V18C1 19.1046 1.89543 20 3 20H21C22.1046 20 23 19.1046 23 18V6C23 4.89543 22.1046 4 21 4Z'
				stroke='#ffffff'
				strokeWidth='2'
				strokeLinecap='round'
				strokeLinejoin='round'
			/>
			<path d='M1 10H23' stroke='#ffffff' strokeWidth='2' strokeLinecap='round' strokeLinejoin='round' />
		</svg>
	),
	logout: ({ height = 24, width = 24, ...props }: Object): React$Element<'svg'> => (
		<svg {...props} width={width} height={height} viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'>
			<path
				d='M9 21H5C4.46957 21 3.96086 20.7893 3.58579 20.4142C3.21071 20.0391 3 19.5304 3 19V5C3 4.46957 3.21071 3.96086 3.58579 3.58579C3.96086 3.21071 4.46957 3 5 3H9'
				stroke='#fffff'
				strokeWidth='2'
				strokeLinecap='round'
				strokeLinejoin='round'
			/>
			<path d='M16 17L21 12L16 7' stroke='#fffff' strokeWidth='2' strokeLinecap='round' strokeLinejoin='round' />
			<path d='M21 12H9' stroke='#fffff' strokeWidth='2' strokeLinecap='round' strokeLinejoin='round' />
		</svg>
	),
	settings: ({ height = 24, width = 24, ...props }: Object): React$Element<'svg'> => (
		<svg {...props} width={width} height={height} viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'>
			<path
				d='M12 15C13.6569 15 15 13.6569 15 12C15 10.3431 13.6569 9 12 9C10.3431 9 9 10.3431 9 12C9 13.6569 10.3431 15 12 15Z'
				stroke='#fffff'
				strokeWidth='2'
				strokeLinecap='round'
				strokeLinejoin='round'
			/>
			<path
				d='M19.4 15C19.2669 15.3016 19.2272 15.6362 19.286 15.9606C19.3448 16.285 19.4995 16.5843 19.73 16.82L19.79 16.88C19.976 17.0657 20.1235 17.2863 20.2241 17.5291C20.3248 17.7719 20.3766 18.0322 20.3766 18.295C20.3766 18.5578 20.3248 18.8181 20.2241 19.0609C20.1235 19.3037 19.976 19.5243 19.79 19.71C19.6043 19.896 19.3837 20.0435 19.1409 20.1441C18.8981 20.2448 18.6378 20.2966 18.375 20.2966C18.1122 20.2966 17.8519 20.2448 17.6091 20.1441C17.3663 20.0435 17.1457 19.896 16.96 19.71L16.9 19.65C16.6643 19.4195 16.365 19.2648 16.0406 19.206C15.7162 19.1472 15.3816 19.1869 15.08 19.32C14.7842 19.4468 14.532 19.6572 14.3543 19.9255C14.1766 20.1938 14.0813 20.5082 14.08 20.83V21C14.08 21.5304 13.8693 22.0391 13.4942 22.4142C13.1191 22.7893 12.6104 23 12.08 23C11.5496 23 11.0409 22.7893 10.6658 22.4142C10.2907 22.0391 10.08 21.5304 10.08 21V20.91C10.0723 20.579 9.96512 20.258 9.77251 19.9887C9.5799 19.7194 9.31074 19.5143 9 19.4C8.69838 19.2669 8.36381 19.2272 8.03941 19.286C7.71502 19.3448 7.41568 19.4995 7.18 19.73L7.12 19.79C6.93425 19.976 6.71368 20.1235 6.47088 20.2241C6.22808 20.3248 5.96783 20.3766 5.705 20.3766C5.44217 20.3766 5.18192 20.3248 4.93912 20.2241C4.69632 20.1235 4.47575 19.976 4.29 19.79C4.10405 19.6043 3.95653 19.3837 3.85588 19.1409C3.75523 18.8981 3.70343 18.6378 3.70343 18.375C3.70343 18.1122 3.75523 17.8519 3.85588 17.6091C3.95653 17.3663 4.10405 17.1457 4.29 16.96L4.35 16.9C4.58054 16.6643 4.73519 16.365 4.794 16.0406C4.85282 15.7162 4.81312 15.3816 4.68 15.08C4.55324 14.7842 4.34276 14.532 4.07447 14.3543C3.80618 14.1766 3.49179 14.0813 3.17 14.08H3C2.46957 14.08 1.96086 13.8693 1.58579 13.4942C1.21071 13.1191 1 12.6104 1 12.08C1 11.5496 1.21071 11.0409 1.58579 10.6658C1.96086 10.2907 2.46957 10.08 3 10.08H3.09C3.42099 10.0723 3.742 9.96512 4.0113 9.77251C4.28059 9.5799 4.48572 9.31074 4.6 9C4.73312 8.69838 4.77282 8.36381 4.714 8.03941C4.65519 7.71502 4.50054 7.41568 4.27 7.18L4.21 7.12C4.02405 6.93425 3.87653 6.71368 3.77588 6.47088C3.67523 6.22808 3.62343 5.96783 3.62343 5.705C3.62343 5.44217 3.67523 5.18192 3.77588 4.93912C3.87653 4.69632 4.02405 4.47575 4.21 4.29C4.39575 4.10405 4.61632 3.95653 4.85912 3.85588C5.10192 3.75523 5.36217 3.70343 5.625 3.70343C5.88783 3.70343 6.14808 3.75523 6.39088 3.85588C6.63368 3.95653 6.85425 4.10405 7.04 4.29L7.1 4.35C7.33568 4.58054 7.63502 4.73519 7.95941 4.794C8.28381 4.85282 8.61838 4.81312 8.92 4.68H9C9.29577 4.55324 9.54802 4.34276 9.72569 4.07447C9.90337 3.80618 9.99872 3.49179 10 3.17V3C10 2.46957 10.2107 1.96086 10.5858 1.58579C10.9609 1.21071 11.4696 1 12 1C12.5304 1 13.0391 1.21071 13.4142 1.58579C13.7893 1.96086 14 2.46957 14 3V3.09C14.0013 3.41179 14.0966 3.72618 14.2743 3.99447C14.452 4.26276 14.7042 4.47324 15 4.6C15.3016 4.73312 15.6362 4.77282 15.9606 4.714C16.285 4.65519 16.5843 4.50054 16.82 4.27L16.88 4.21C17.0657 4.02405 17.2863 3.87653 17.5291 3.77588C17.7719 3.67523 18.0322 3.62343 18.295 3.62343C18.5578 3.62343 18.8181 3.67523 19.0609 3.77588C19.3037 3.87653 19.5243 4.02405 19.71 4.21C19.896 4.39575 20.0435 4.61632 20.1441 4.85912C20.2448 5.10192 20.2966 5.36217 20.2966 5.625C20.2966 5.88783 20.2448 6.14808 20.1441 6.39088C20.0435 6.63368 19.896 6.85425 19.71 7.04L19.65 7.1C19.4195 7.33568 19.2648 7.63502 19.206 7.95941C19.1472 8.28381 19.1869 8.61838 19.32 8.92V9C19.4468 9.29577 19.6572 9.54802 19.9255 9.72569C20.1938 9.90337 20.5082 9.99872 20.83 10H21C21.5304 10 22.0391 10.2107 22.4142 10.5858C22.7893 10.9609 23 11.4696 23 12C23 12.5304 22.7893 13.0391 22.4142 13.4142C22.0391 13.7893 21.5304 14 21 14H20.91C20.5882 14.0013 20.2738 14.0966 20.0055 14.2743C19.7372 14.452 19.5268 14.7042 19.4 15V15Z'
				stroke='#fffff'
				strokeWidth='2'
				strokeLinecap='round'
				strokeLinejoin='round'
			/>
		</svg>
	),

	'pie-chart': ({ width = 24, height = 24, stroke = '#3857F7', ...props }: Object): React$Element<'svg'> => (
		<svg {...props} width={width} height={height} viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'>
			<path
				d='M21.21 15.89C20.5738 17.3945 19.5788 18.7202 18.3119 19.7513C17.045 20.7824 15.5448 21.4874 13.9424 21.8048C12.3401 22.1221 10.6844 22.0421 9.12015 21.5718C7.55587 21.1015 6.13062 20.2551 4.96902 19.1067C3.80741 17.9582 2.94481 16.5428 2.45663 14.984C1.96845 13.4251 1.86956 11.7705 2.1686 10.1646C2.46763 8.55878 3.15549 7.05063 4.17204 5.77203C5.18859 4.49343 6.50288 3.48332 8 2.83'
				stroke={stroke}
				strokeWidth='2'
				strokeLinecap='round'
				strokeLinejoin='round'
			/>
			<path
				d='M22 12C22 10.6868 21.7413 9.38642 21.2388 8.17317C20.7362 6.95991 19.9997 5.85752 19.0711 4.92893C18.1425 4.00035 17.0401 3.26375 15.8268 2.7612C14.6136 2.25866 13.3132 2 12 2V12H22Z'
				stroke={stroke}
				strokeWidth='2'
				strokeLinecap='round'
				strokeLinejoin='round'
			/>
		</svg>
	),

	'thumbs-up': ({ width = 24, height = 24, stroke = '#3857F7', ...props }: Object): React$Element<'svg'> => (
		<svg width={width} height={height} viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'>
			<path
				d='M7 22H4C3.46957 22 2.96086 21.7893 2.58579 21.4142C2.21071 21.0391 2 20.5304 2 20V13C2 12.4696 2.21071 11.9609 2.58579 11.5858C2.96086 11.2107 3.46957 11 4 11H7M14 9V5C14 4.20435 13.6839 3.44129 13.1213 2.87868C12.5587 2.31607 11.7956 2 11 2L7 11V22H18.28C18.7623 22.0055 19.2304 21.8364 19.5979 21.524C19.9654 21.2116 20.2077 20.7769 20.28 20.3L21.66 11.3C21.7035 11.0134 21.6842 10.7207 21.6033 10.4423C21.5225 10.1638 21.3821 9.90629 21.1919 9.68751C21.0016 9.46873 20.7661 9.29393 20.5016 9.17522C20.2371 9.0565 19.9499 8.99672 19.66 9H14Z'
				stroke={stroke}
				strokeWidth='2'
				strokeLinecap='round'
				strokeLinejoin='round'
			/>
		</svg>
	),
	'api-key': ({ width = 24, height = 24, stroke = '#3857F7', ...props }: Object): React$Element<'svg'> => (
		<svg xmlns='http://www.w3.org/2000/svg' fill='none' viewBox='0 0 24 24' strokeWidth='2.5' stroke={stroke}>
			<path
				strokeLinecap='round'
				strokeLinejoin='round'
				d='M17.25 6.75L22.5 12l-5.25 5.25m-10.5 0L1.5 12l5.25-5.25m7.5-3l-4.5 16.5'
			/>
		</svg>
	),
	paypal: ({ width = 40, height = 40, stroke = '#3857F7', ...props }: Object): React$Element<'svg'> => (
		<svg
			stroke={stroke}
			fill={stroke}
			strokeWidth='0'
			viewBox='0 0 16 16'
			height='1em'
			width='1em'
			xmlns='http://www.w3.org/2000/svg'
		>
			<path d='M0 4a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V4zm2-1a1 1 0 0 0-1 1v1h14V4a1 1 0 0 0-1-1H2zm13 4H1v5a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V7z'></path>
			<path d='M2 10a1 1 0 0 1 1-1h1a1 1 0 0 1 1 1v1a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1v-1z'></path>
		</svg>
	),
	mpesa: ({ width = 40, height = 40, ...props }: Object): React$Element<'svg'> => (
		<svg
			stroke='#84879A'
			fill='#84879A'
			strokeWidth='0'
			viewBox='0 0 24 24'
			height='1em'
			width='1em'
			xmlns='http://www.w3.org/2000/svg'
		>
			<path fill='none' d='M0 0h24v24H0V0z'></path>
			<path d='M18 8l4 4-4 4-1.41-1.41L18.17 13H13v-2h5.17l-1.59-1.59L18 8zM7 1.01L17 1c1.1 0 2 .9 2 2v4h-2V6H7v12h10v-1h2v4c0 1.1-.9 2-2 2H7c-1.1 0-2-.9-2-2V3c0-1.1.9-1.99 2-1.99zM7 21h10v-1H7v1zM7 4h10V3H7v1z'></path>
		</svg>
	),
	bank: ({ width = 25, height = 25, stroke = '#3857F7', ...props }: Object): React$Element<'svg'> => (
		<svg width={width} height={height} fill={stroke} xmlns='http://www.w3.org/2000/svg' viewBox='0 0 1024 1024'>
			<path d='M894 462c30.9 0 43.8-39.7 18.7-58L530.8 126.2a31.81 31.81 0 0 0-37.6 0L111.3 404c-25.1 18.2-12.2 58 18.8 58H192v374h-72c-4.4 0-8 3.6-8 8v52c0 4.4 3.6 8 8 8h784c4.4 0 8-3.6 8-8v-52c0-4.4-3.6-8-8-8h-72V462h62zM381 836H264V462h117v374zm189 0H453V462h117v374zm190 0H642V462h118v374z'></path>
		</svg>
	),
	airtel: ({ width = 30, height = 30, ...props }: Object): React$Element<'svg'> => (
		<svg width={width} height={height} xmlns='http://www.w3.org/2000/svg' viewBox='0 0 122.8 123.79'>
			<path
				xmlns='http://www.w3.org/2000/svg'
				className='airtel_path-1'
				d='M68.09.1a6.16,6.16,0,0,1-1.24.15,41.48,41.48,0,0,0-9.53,2.4l-1.19.49a43.68,43.68,0,0,0-5,2.41,3.57,3.57,0,0,1-.89.41c-.25.06-.45.18-.45.25s-.14.17-.29.24a4.26,4.26,0,0,0-.82.44,7.92,7.92,0,0,1-.9.51,4.68,4.68,0,0,0-.95.59,2.88,2.88,0,0,1-.66.43,60.55,60.55,0,0,0-7.39,5.36,30.85,30.85,0,0,0-3.58,3.81,1.82,1.82,0,0,1-.36.51A30.7,30.7,0,0,0,32.34,22c-.18.42-.56,1.17-.8,1.68a11.49,11.49,0,0,0-1.08,5.7,6.08,6.08,0,0,0,2,4.68,7.81,7.81,0,0,0,5.66,2.31,13.61,13.61,0,0,0,4.76-.54c.55-.16,1.3-.34,1.66-.45a4.11,4.11,0,0,0,.93-.32c.39-.2,2.58-1.19,2.68-1.19a65,65,0,0,0,7.2-4.39c2.18-1.46,4.1-2.73,4.27-2.82s1.19-.71,2.29-1.37,2.46-1.43,3-1.71l1.78-.94c.43-.2,1.22-.57,1.78-.78s1.26-.51,1.53-.63.7-.3.93-.4a14.41,14.41,0,0,1,3.62-.65,6,6,0,0,1,6.5,4.11,8.52,8.52,0,0,1,.32,3.31A12.77,12.77,0,0,1,80.53,33l-.43,1a38.38,38.38,0,0,1-4.6,7.6,65.43,65.43,0,0,1-8.68,9l-2.29,1.9c-.72.59-1.55,1.18-2.46,1.8-.38.23-1,.64-1.36.91a45.69,45.69,0,0,1-5.43,2.89l-1.39.61A2.68,2.68,0,0,1,53,59a3.67,3.67,0,0,0-.86.19,1.62,1.62,0,0,1-2.22-1.49c0-1.39.66-2.28,4.83-6.42,4.51-4.47,5-5.14,5-6.83s-.83-2.94-2.7-3.89a4.28,4.28,0,0,0-2.55-.47,6.48,6.48,0,0,0-3.83,1c-.27.17-.7.39-.93.51a2.87,2.87,0,0,0-.51.31s-.39.3-.77.59a22.74,22.74,0,0,0-3.37,3.46A23.84,23.84,0,0,0,43,49.47,17.39,17.39,0,0,0,41.28,56c0,3.65,1.9,6.57,4.84,7.4a22.7,22.7,0,0,0,5.72,0A32.26,32.26,0,0,0,56.45,62a.73.73,0,0,1,.41-.15,52,52,0,0,0,7.21-3.68c.39-.26.83-.55,1-.65s1-.57,1.78-1.08,1.53-1,1.58-1a14.7,14.7,0,0,1,1.27-.93l1.7-1.17c.29-.21,1.08-.82,1.78-1.38A68,68,0,0,0,83.77,41.75c.37-.45.71-.88.76-.93a35.5,35.5,0,0,0,2.09-3,22.9,22.9,0,0,0,1.2-2.07c.32-.61.77-1.44,1-1.87s.69-1.52,1.06-2.46.72-1.85.78-2a38.46,38.46,0,0,0,1.53-6.53,25,25,0,0,0-.61-8.91,15.54,15.54,0,0,0-1-2.46,18.56,18.56,0,0,0-6-7.3,9.1,9.1,0,0,1-1-.74A23.19,23.19,0,0,0,78.08,1a27.86,27.86,0,0,0-3.2-.72C73.79.11,71.82,0,70.27,0h-.79a6.8,6.8,0,0,0-1.39.1ZM36.45,92.74a15.57,15.57,0,0,1-1.7.32c-.64.08-1.83.25-2.63.37a8.81,8.81,0,0,0-1.58.31c-.15.13-.17,29,0,29.21a20.27,20.27,0,0,0,3.56.16c3.46,0,3.48,0,3.57-.39,0-.21.06-7.06,0-15.22,0-14.71,0-14.85-.39-14.88a2.58,2.58,0,0,0-.85.12ZM32.29,80.49a4.72,4.72,0,0,0-2.24,1.81c-.54.83-.56.9-.56,2.63v1.8l.65.88a4.19,4.19,0,0,0,2.39,1.8,4.75,4.75,0,0,0,4.33-.64c1.81-1.16,2.44-4.11,1.34-6.28a3.92,3.92,0,0,0-1.75-1.76,5.52,5.52,0,0,0-4.16-.24Zm62.1,17.34c.71.18,2.2,1.39,2.2,1.76a2.15,2.15,0,0,0,.26.66c.39.77.69,3.28.42,3.6s-.83.25-4.26.25H89l-.1-.42a7,7,0,0,1,1-4.09,4.31,4.31,0,0,1,2.39-1.8,4.5,4.5,0,0,1,1.19-.22c.1,0,.51.16.9.26Zm-3.65-5.4a3.87,3.87,0,0,0-1.17.32.67.67,0,0,1-.41.16,5.73,5.73,0,0,0-1.34.54,12.84,12.84,0,0,0-4.16,3.87A17.08,17.08,0,0,0,81.92,101a5.62,5.62,0,0,1-.26.84c-.06.19-.27.92-.44,1.62a33,33,0,0,0,0,9.41,17,17,0,0,0,1.5,4,.17.17,0,0,1,.15.19c0,.64,2,3.2,3.44,4.36A12.72,12.72,0,0,0,89.38,123a20.56,20.56,0,0,0,4.77.82c2.41,0,6.75-1,8.19-2a5.32,5.32,0,0,1,1-.5,5.32,5.32,0,0,0,1.76-1.09,14.4,14.4,0,0,0-2-4.09,1.57,1.57,0,0,0-.66.34,1.52,1.52,0,0,1-.66.34,1.22,1.22,0,0,0-.56.24,17.24,17.24,0,0,1-2,.78,8.94,8.94,0,0,1-4,.57c-2.1,0-2.46,0-3.14-.35-2.37-1.14-3.73-4-3.73-7.87a12,12,0,0,1,0-1.55s3.78-.08,8.35-.13l8.31-.09,0-1.7c-.1-3.32-1-7.8-1.75-8.82-.07-.1-.3-.52-.52-1a9,9,0,0,0-5.14-4.14,17.22,17.22,0,0,0-7-.39Zm-36.9,0a18.87,18.87,0,0,0-8.79,4.71l-.71.65v25.06c0,.27.25.29,3.7.25l3.68,0,.05-11.82,0-11.81.65-.51a5.63,5.63,0,0,1,2.12-1.14A11.67,11.67,0,0,1,59,97.32a6.14,6.14,0,0,0,1.42.05,3.94,3.94,0,0,0,.7-1.29c.25-.68.66-1.56.86-2,.56-1.07.51-1.34-.24-1.51l-1.46-.34a20.94,20.94,0,0,0-6.39.14ZM16.51,108.35a32.6,32.6,0,0,1,.17,4.59c0,4.82.07,4.52-1.19,5.18a5.82,5.82,0,0,1-2.64.32H10.79l-.84-.58a5,5,0,0,1-1.19-1.1A6.31,6.31,0,0,1,8.91,110a6.88,6.88,0,0,1,2.16-1.52.72.72,0,0,0,.45-.16c.24-.25,1-.32,3-.29,1.42,0,1.86.07,2,.28ZM11.51,92a27,27,0,0,0-5.26,1.26c-.19.08-.53.2-.77.27a14,14,0,0,0-3.22,1.61,5.69,5.69,0,0,0,.32.88,22.72,22.72,0,0,0,1.63,3.34,1.34,1.34,0,0,0,.39-.15,19.4,19.4,0,0,1,2.75-1.12c.51-.15,1.12-.35,1.36-.44a13.41,13.41,0,0,1,4.65-.32c2.3.37,3.15,1.44,3.29,4.17.07,1.51.07,1.55-.32,1.65a30.09,30.09,0,0,1-3.47.12c-4,0-5.27.23-7.88,1.51a9.16,9.16,0,0,0-4.7,5.78A11.46,11.46,0,0,0,.38,116c1.52,4.62,5.16,7.31,10.21,7.58A18.79,18.79,0,0,0,23,120l1.1-.9.05-9c.05-10.4,0-10.76-1.22-13.3a9.62,9.62,0,0,0-3.61-3.5c-.54-.25-1.14-.51-1.33-.59A17.09,17.09,0,0,0,11.51,92ZM70.3,84.34c-3.77.56-5,.8-5.18,1S65,90.87,65,101.22c.08,14.46.11,15.76.39,16.46a7.31,7.31,0,0,0,1.85,3.09c1.78,1.78,4,2.51,7.78,2.51,2.07,0,2.36,0,2.5-.31a16.73,16.73,0,0,0,.12-4c-.11-.43-.17-.44-1.45-.55A3.5,3.5,0,0,1,73,116.66l-.42-.76-.06-8.79c0-6.55,0-8.86.16-9s.73-.23,2.54-.23c2.8,0,2.56.27,2.5-3l0-2.21-2.38-.08a17.43,17.43,0,0,1-2.58-.22c-.17-.1-.22-1.14-.22-4.21V84.08l-.37,0c-.22,0-1,.12-1.83.24Zm47-.34s-.83.19-1.76.34-2.46.39-3.39.56l-1.7.29V100.8c0,17,0,16.23,1,18.35a6.15,6.15,0,0,0,1.54,2c1.8,1.65,3.48,2.16,7.06,2.17,3.05,0,2.93.12,2.87-2.69l0-2-1.31-.12c-2.32-.2-3.44-1.14-3.7-3.07-.07-.58-.12-7.84-.1-16.12,0-14.33,0-15.71-.43-15.3Z'
			/>
		</svg>
	),
	'bulk-data': ({ width = 24, height = 24, stroke = '#3857F7', ...props }: Object): React$Element<'svg'> => (
		<svg fill='none' viewBox='0 0 24 24' strokeWidth='1.5' stroke={stroke} xmlns='http://www.w3.org/2000/svg'>
			<path
				strokeLinecap='round'
				strokeLinejoin='round'
				d='M8.288 15.038a5.25 5.25 0 017.424 0M5.106 11.856c3.807-3.808 9.98-3.808 13.788 0M1.924 8.674c5.565-5.565 14.587-5.565 20.152 0M12.53 18.22l-.53.53-.53-.53a.75.75 0 011.06 0z'
			></path>
		</svg>
	),
	airtime: ({ width = 24, height = 24, stroke = '#3857F7', ...props }: Object): React$Element<'svg'> => (
		<svg
			xmlns='http://www.w3.org/2000/svg'
			fill='none'
			viewBox='0 0 24 24'
			strokeWidth='1.5'
			stroke={stroke}
			// class='w-6 h-6'
		>
			<path
				strokeLinecap='round'
				strokeLinejoin='round'
				d='M2.25 6.75c0 8.284 6.716 15 15 15h2.25a2.25 2.25 0 002.25-2.25v-1.372c0-.516-.351-.966-.852-1.091l-4.423-1.106c-.44-.11-.902.055-1.173.417l-.97 1.293c-.282.376-.769.542-1.21.38a12.035 12.035 0 01-7.143-7.143c-.162-.441.004-.928.38-1.21l1.293-.97c.363-.271.527-.734.417-1.173L6.963 3.102a1.125 1.125 0 00-1.091-.852H4.5A2.25 2.25 0 002.25 4.5v2.25z'
			></path>
		</svg>
	),
	'send-bulk-money': ({ width = 24, height = 24, stroke = '#3857F7', ...props }: Object): React$Element<'svg'> => (
		<svg xmlns='http://www.w3.org/2000/svg' fill='none' viewBox='0 0 24 24' strokeWidth='1.5'>
			<path
				strokeLinecap='round'
				strokeLinejoin='round'
				d='M2.25 18.75a60.07 60.07 0 0115.797 2.101c.727.198 1.453-.342 1.453-1.096V18.75M3.75 4.5v.75A.75.75 0 013 6h-.75m0 0v-.375c0-.621.504-1.125 1.125-1.125H20.25M2.25 6v9m18-10.5v.75c0 .414.336.75.75.75h.75m-1.5-1.5h.375c.621 0 1.125.504 1.125 1.125v9.75c0 .621-.504 1.125-1.125 1.125h-.375m1.5-1.5H21a.75.75 0 00-.75.75v.75m0 0H3.75m0 0h-.375a1.125 1.125 0 01-1.125-1.125V15m1.5 1.5v-.75A.75.75 0 003 15h-.75M15 10.5a3 3 0 11-6 0 3 3 0 016 0zm3 0h.008v.008H18V10.5zm-12 0h.008v.008H6V10.5z'
			></path>
		</svg>
	),
}

export type IconNamesEnum = $Keys<typeof icons>

type IconProps = {
	name: IconNamesEnum,
	width?: number,
	height?: number,
	className?: string,
	stroke?: string,
	[string]: mixed,
}
function Icon({
	name,
	...props
}: IconProps): React$Element<React$ComponentType<{ children?: React$Node, fallback?: React$Node, ... }>> {
	if (!icons[name]) {
		throw new Error("Icon with provided name doesn't exist")
	}

	const IconComponent = icons[name]

	const fallbackStyle = useMemo(() => ({ width: 15, height: 15 }), [])
	return (
		<Suspense fallback={<div style={fallbackStyle} />}>
			<IconComponent {...props} />
		</Suspense>
	)
}

export default Icon

type IconActionType = {
	name: IconNamesEnum,
	width?: number,
	height?: number,
	stroke?: string,
	onClick?: Function,
	withSiblings?: boolean,
	className?: string,
	type?: string,
	disabled?: boolean,
	[string]: mixed,
}
const IconAction = ({
	name,
	width = 22,
	height = 22,
	stroke = '#84879A',
	onClick,
	withSiblings,
	className,
	type,
	...props
}: IconActionType): React$Element<'button'> => {
	const cs = cx('IconAction', className, { 'IconAction--with-siblings': withSiblings, 'IconAction--disabled': props.disabled })

	return (
		<button {...props} className={cs} onClick={onClick} type={type} disabled={props.disabled}>
			<Icon {...props} width={width} height={height} name={name} stroke={stroke} data-testid='' />
		</button>
	)
}

export { Icon, IconAction }
